"use client";
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogOverlay,
    AlertDialogTitle,
    AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import {
    Popover,
    PopoverTrigger,
    PopoverContent,
} from "@/components/ui/popover";
import { Separator } from "@/components/ui/separator";
import { Switch } from "@/components/ui/switch";
import { Toggle } from "@/components/ui/toggle";
import { IBlocks } from "@/types";
import {
    IconEye,
    IconEyeCancel,
    IconEyeOff,
    IconTrash,
} from "@tabler/icons-react";
import React, { useState } from "react";

interface Props {
    block: IBlocks;
    blockUpdate: React.Dispatch<React.SetStateAction<IBlocks>>;
    update: (value: IBlocks) => void;
}

export default function BlockToggle({ block, blockUpdate, update }: Props) {
    const changeShow = (value: boolean) => {
        update({
            ...block,
            show: value,
        });
    };

    return (
        <div className="flex items-center gap-3">
            {/* <div className="flex items-center gap-2">
                {block.show ? <IconEye /> : <IconEyeOff />}
                <Switch checked={block.show} onCheckedChange={changeShow} /> */}
            <Toggle
                className={`${block.show ? "" : "text-copy-lighter bg-transparent"}`}
                pressed={block.show}
                onPressedChange={changeShow}
            >
                {block.show ? <IconEye /> : <IconEyeOff />}
            </Toggle>
            {/* </div> */}
            <AlertDialog>
                <AlertDialogTrigger asChild>
                    <Button className="h-9 w-9 bg-destructive/10 p-0 hover:bg-destructive">
                        <IconTrash aria-label="Delete" />
                    </Button>
                </AlertDialogTrigger>
                <AlertDialogOverlay className="z-[999]" />
                <AlertDialogContent className="z-[999] w-fit max-w-[95%] rounded-md p-3">
                    <AlertDialogHeader className="w-fit">
                        <AlertDialogTitle className="w-fit">
                            Are you sure you want to delete "{block.name}" ?
                        </AlertDialogTitle>
                    </AlertDialogHeader>
                    <AlertDialogFooter className="w-fit">
                        <AlertDialogCancel>Cancel</AlertDialogCancel>
                        <AlertDialogAction
                            onClick={() => {
                                [
                                    //@ts-ignore
                                    update(null),
                                    window.dispatchEvent(
                                        new CustomEvent("closeBlock", {
                                            detail: {
                                                id: "-1",
                                            },
                                        })
                                    ),
                                    window.dispatchEvent(
                                        new CustomEvent("collapseBlock")
                                    ),
                                ];
                            }}
                        >
                            Delete
                        </AlertDialogAction>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialog>
        </div>
    );
}
